export const getStatusStyle = (theme?: any, status?: string) => {
  switch (String(status)?.toLowerCase()) {
    case 'active':
      return {
        color: theme.palette.success.main,
        bg: theme.palette.success.light,
        label: 'Active'
      };

    case 'past_due':
      return {
        color: theme.palette.warning.main,
        bg: theme.palette.warning.light,
        label: 'Past Due'
      };

    case 'inactive':
      return {
        color: theme.palette.error.main,
        bg: theme.palette.error.light,
        label: 'Inactive'
      };

    case 'archived':
      return {
        color: theme.palette.purple.main,
        bg: theme.palette.purple.light,
        label: 'Archived'
      };

    default:
      return {
        color: theme.palette.secondary.main,
        bg: theme.palette.border.main,
        label: status ?? 'Unknown'
      };
  }
};
